import { render } from "./ViewCommunity.vue?vue&type=template&id=2f2e19e4"
import script from "./ViewCommunity.vue?vue&type=script&lang=js"
export * from "./ViewCommunity.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__